import { render } from "./ListPage.vue?vue&type=template&id=aca564cc"
import script from "./ListPage.vue?vue&type=script&lang=js"
export * from "./ListPage.vue?vue&type=script&lang=js"
script.render = render

export default script